<template>
  <q-dialog
      ref="dialog"
      class="dialog"
      :persistent="persistent"
      @hide="onDialogHide"
  >
    <q-card class="q-dialog-plugin">
      <q-card-section class="row items-center" :class="{'q-px-lg': $isDesktop}">
        <div v-if="title" class="heading-3 q-mr-sm">{{ title }}</div>
        <q-space/>
        <icon-button v-if="!persistent" icon="close" aria-label="Sluit dialoogvenster" size="sm" round v-close-popup/>
      </q-card-section>
      <q-card-section class="dialog__messages" :class="$isMobile ? 'q-pb-none' : 'q-px-lg q-pb-sm'">
        <slot>
          <p
              v-for="message in messages"
              :key="message"
          >
            {{ message }}
          </p>
          </slot>
      </q-card-section>
      <q-separator />
      <q-card-actions :class="$isMobile ? 'q-pa-md' : 'q-px-lg q-py-md'">
        <slot name="actions">
          <accent-button
              v-if="ok"
              :label="ok.label"
              @click="onOKClick"
          />
          <flat-button
              v-if="cancel && !hideCancelButton"
              :label="cancel.label"
              @click="onCancelClick"
          />
        </slot>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  props: [
    'title',
    'messages',
    'persistent',
    'hideCancelButton',
    'cancel',
    'ok',
  ],
  emits: [
    'ok', 'hide'
  ],
  methods: {
    show () {
      this.$refs.dialog.show()
    },
    hide () {
      this.$refs.dialog.hide()
    },
    onDialogHide () {
      this.$emit('hide')
    },
    onOKClick () {
      this.$emit('ok')
      this.hide()
    },
    onCancelClick () {
      this.hide()
    }
  }
}
</script>
